import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as PreferenceActions from './preference.actions';
import { AccountClientService } from '@mode/shared/data-access-webapp';

@Injectable()
export class PreferenceEffects {
  loadPreferences$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PreferenceActions.loadPreferences),
      switchMap((action) => this.client.getUserPreferences(action.username)),
      map((prefs) =>
        PreferenceActions.loadPreferencesSuccess({
          prefs,
        })
      ),
      catchError((error) => of(PreferenceActions.loadPreferencesFailure({ error })))
    );
  });

  constructor(private actions$: Actions, private client: AccountClientService) {}
}
